import React from 'react';
import Container from '@mui/material/Container';
import { IndexFundNavTab } from './IndexFundNavTab';

export function IndexFundNav() {
  return (
    <Container component="main" maxWidth="xl">
      <IndexFundNavTab />
    </Container>
  );
}
